
export enum InvoicePreferenceConstraintCd {
	ACCESSORIAL_CD = 'AccessorialCd',
	BILLING_TYPE_CD = 'BillingTypeCd',
	INVOICE_CURRENCY = 'InvoiceCurrency',
	INVOICE_TYPE_CD = 'InvoiceTypeCd',
	SHIPMENT_WEIGHT = 'ShipmentWeight'}

